import { Card, Col, Row, Typography, Space } from "antd";
import {
  HeartOutlined,
  MedicineBoxOutlined,
  EyeOutlined,
  UserOutlined,
  ExperimentOutlined,
  WarningOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const SymptomsPage = () => {
  const symptoms = [
    {
      text: "Ipertrofia cardiaca sproporzionata rispetto all'anamnesi",
      category: "cardiaco",
      icon: <HeartOutlined />,
    },
    {
      text: "Multipli ricoveri per scompenso cardiaco",
      category: "cardiaco",
      icon: <HeartOutlined />,
    },
    {
      text: "BNP o NT pro BNP elevato",
      category: "lab",
      icon: <ExperimentOutlined />,
    },
    {
      text: "Stenosi aortica",
      category: "cardiaco",
      icon: <HeartOutlined />,
    },
    {
      text: "Ipotensione o normotensione in soggetto precedentemente iperteso",
      category: "cardiaco",
      icon: <HeartOutlined />,
    },
    {
      text: "Familiarità per cardiomiopatia rara",
      category: "familiare",
      icon: <UserOutlined />,
    },
    {
      text: "Polineuropatia",
      category: "neurologico",
      icon: <MedicineBoxOutlined />,
    },
    {
      text: "Disautonomia",
      category: "neurologico",
      icon: <MedicineBoxOutlined />,
    },
    {
      text: "Insufficienza renale",
      category: "renale",
      icon: <ExperimentOutlined />,
    },
    {
      text: "Tunnel carpale bilaterale",
      category: "muscoloscheletrico",
      icon: <UserOutlined />,
    },
    {
      text: "Rottura tendine bicipitale",
      category: "muscoloscheletrico",
      icon: <UserOutlined />,
    },
    {
      text: "Sintomi gastrointestinali",
      category: "gastrointestinale",
      icon: <UserOutlined />,
    },
    {
      text: "Progressiva perdita dell'udito",
      category: "sensoriale",
      icon: <EyeOutlined />,
    },
    {
      text: "TIA/Stroke in età giovanile",
      category: "neurologico",
      icon: <WarningOutlined />,
    },
    {
      text: "Linfedema",
      category: "vascolare",
      icon: <UserOutlined />,
    },
    {
      text: "Angiocheratomi o cornea verticillata",
      category: "dermatologico",
      icon: <EyeOutlined />,
    },
    {
      text: "Livello di colesterolo > 300 mg/dl",
      category: "lab",
      icon: <ExperimentOutlined />,
    },
    {
      text: "Eventi cardiovascolari in età precoce (prima dei 55 anni per gli uomini, prima dei 60 anni per le donne)",
      category: "cardiaco",
      icon: <HeartOutlined />,
    },
  ];

  const getCategoryColor = (category: string) => {
    const colors: Record<string, string> = {
      cardiaco: "red",
      neurologico: "purple",
      lab: "blue",
      familiare: "green",
      renale: "orange",
      muscoloscheletrico: "cyan",
      gastrointestinale: "magenta",
      sensoriale: "gold",
      vascolare: "lime",
      dermatologico: "pink",
    };
    return colors[category] || "default";
  };

  const getCategoryLabel = (category: string) => {
    const labels: Record<string, string> = {
      cardiaco: "Cardiaco",
      neurologico: "Neurologico",
      lab: "Laboratorio",
      familiare: "Familiare",
      renale: "Renale",
      muscoloscheletrico: "Muscoloscheletrico",
      gastrointestinale: "Gastrointestinale",
      sensoriale: "Sensoriale",
      vascolare: "Vascolare",
      dermatologico: "Dermatologico",
    };
    return labels[category] || category;
  };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <Title level={1} style={{ color: "#d32f2f", marginBottom: "8px" }}>
              Red Flags Malattie Rare
            </Title>
            <Text type="secondary" style={{ fontSize: "16px" }}>
              Segni e sintomi da non sottovalutare nella pratica clinica
            </Text>
          </div>

          <Row gutter={[16, 16]}>
            {symptoms.map((symptom, index) => (
              <Col xs={24} sm={12} md={8} lg={6} key={index}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                  bodyStyle={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div
                      style={{
                        marginBottom: "12px",
                        textAlign: "center",
                        color: getCategoryColor(symptom.category),
                      }}
                    >
                      <span style={{ fontSize: "24px" }}>{symptom.icon}</span>
                    </div>
                    <Text
                      style={{
                        fontSize: "14px",
                        lineHeight: "1.6",
                        display: "block",
                        textAlign: "center",
                      }}
                    >
                      {symptom.text}
                    </Text>
                  </div>
                  <div
                    style={{
                      marginTop: "12px",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ color: getCategoryColor(symptom.category) }}>
                      {getCategoryLabel(symptom.category)}
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Space>
      </div>
    </div>
  );
};

export default SymptomsPage;
